import React from 'react'
import './sideDrawer.css'
import MenuIten from './MenuIten';

class SideDrawer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            drawerOpen: this.props.drawerOpen,
        }
    }
    componentDidMount() {
        //Escuta O redimensionamento da tela
        if(document.getElementById("toolbar-children")) {
            window.addEventListener('resize', this.updateDimensions);
            this.updateDimensions()
            console.log('update')
        }
        setInterval(() => {
            this.updateDimensions()
        }, 100);
      }
      componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
      }

    updateDimensions = () => {
        const element = document.getElementById("toolbar-children")
        if (element) {
            const heightToolbar = element.clientHeight
            document.getElementById("drawer-header").style.height = `calc(${heightToolbar}px + 10px)`
        }
        
    };
    teste = () => {
        console.log('foi')
    }
    toogle = () => {
        this.props.toggle()
        setTimeout(() => {
            this.updateDimensions();
        }, 550);
    }


    render() {
        return (
            <div>
                <nav className={`side-drawer ${this.props.drawerOpen ? 'drawer-open' : ''}`}>
                    
                    <div className='drawer-header' id='drawer-header'>
                        <div className={`drawer-client-logo ${!this.props.drawerOpen ? 'drawer-client-logo-close' : ''}`}>
                            {this.props.drawerOpen ? (
                                <img src={this.props.userData.customer.urlLogo} className='img-drawer-open' alt="" />
                            ) : <div style={{ backgroundImage: `url('${this.props.userData.customer.urlLogo.replace('.png', '_thumb.png')}')` }} className='img-drawer-close' />}
                        </div>
                    </div>

                    <div className={`drawer-user-avatar ${!this.props.drawerOpen ? 'drawer-user-avatar-close' : ''}`}>
                        
                        <div className="user-thumb" style={{backgroundImage:`url('https://img.icons8.com/external-kiranshastry-lineal-kiranshastry/1000/FFFFFF/external-user-interface-kiranshastry-lineal-kiranshastry.png')` }} />
                     


                        {this.props.drawerOpen ? (
                            <div style={{ display: 'flex', flexDirection: 'column', width: '70%', marginLeft: '10px' }}>
                                <span style={{ fontSize: '20px', color: '#fff' }}>{this.props.userData.fullname}</span>
                                <span style={{ fontSize: '15px', color: '#fff' }}>{this.props.userData.department}</span>
                            </div>
                        ) : null}

                    </div>

                    <div className='itens-drawer'>
                        {this.props.navItens.itens.map((d, i) => {
                            return (
                                <div key={i}>
                                    <MenuIten id={`tg-${i}`} data={d} clientModules={this.props.userData.modules} drawerOpen={this.props.drawerOpen} _updateDimensions={this.updateDimensions} _toggleDrawer={() => this.toogle()}/>
                                </div>
                            )
                        })}
                    </div>

                    <div className="toogle-button" onClick={() => this.toogle()}>
                        <div className={`chevron-icon ${this.props.drawerOpen ? '' : 'toogle-icon-close'}`} />
                    </div>

                    <div className={`logoff-button ${this.props.drawerOpen ? '' : 'logoff-icon-close'}`}onClick={() => this.props.logoff()}>
                        <div className={`cancel-icon`} />
                        {this.props.drawerOpen ? <span>Sair</span> : null}
                    </div>

                    <div className={`${this.props.drawerOpen ? 'footer-drawer' : 'footer-drawer-close'}`}>
                        <span className='copyright copyright-icon'/>
                        <a href="https://www.telemetry.com.br/" target="_blank" rel="noreferrer" className='footer-drawer-link'>Telemetry</a>
                    </div>

                </nav>
            </div>
        )
    }
}

export default SideDrawer